<script setup lang="ts">
import type { BrokerHighlightsProps } from '.';

import { getBrokerHighlightsStyles } from '.';

const props = withDefaults(defineProps<BrokerHighlightsProps>(), {
	variant: 'light',
	layout: 'fixed'
});

const styles = computed(() =>
	getBrokerHighlightsStyles(props.variant, props.layout)
);
</script>

<template>
	<div :class="styles.list">
		<div
			v-for="(item, index) in items"
			:key="`${item.label}-${index}`"
			:class="styles.card"
		>
			<div class="flex flex-col gap-1">
				<span :class="styles.value">{{ item.value }}</span>
				<span :class="styles.label">{{ item.label }}</span>
			</div>
		</div>
	</div>
</template>
